import React from "react";
import "./SuccessPage.scss";
import MuiButton from "../../components/basicComponent/MuiButton";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import HomeIcon from "@mui/icons-material/Home";
import HistoryIcon from "@mui/icons-material/History";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { useLocation, useNavigate } from "react-router-dom";
import { UtilService } from "../../services/shared/UtilService";
import CheckIcon from "@mui/icons-material/Check";

const HotelBookingConfirmation: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const id = location?.state?.id;
  const bookingRes = location?.state?.bookingRes;
  const addressDetail = bookingRes?.booking_req?.AddressDetail;
  const hotelreservation = bookingRes?.booking_req?.HotelReservationInfo;

  const downloadHotelTicket = async () => {
    try {
      const response = (await UtilService.downloadHotelTicket(id)) as any;
      // Create a blob link
      const blob = new Blob([response?.data], { type: "application/pdf" });
      const blobUrl = window.URL.createObjectURL(blob);

      // Create a link and simulate click
      const link = document.createElement("a");
      link.href = blobUrl;

      // Optional: Use Content-Disposition or fallback filename
      const contentDisposition = response?.headers["content-disposition"];
      const fileNameMatch = contentDisposition?.match(/filename="(.+)"/);
      const fileName =
        hotelreservation.Title +
          hotelreservation.firstName +
          hotelreservation.lastName || "ticket.pdf";

      link.download = fileName;
      document.body.appendChild(link);
      link.click();

      // Clean up
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.log("error while download ticket", error);
    }
  };

  const calculateNights = (
    checkInDate: string,
    checkOutDate: string
  ): number => {
    const checkIn = new Date(checkInDate);
    const checkOut = new Date(checkOutDate);

    // Get the time difference in milliseconds
    const diffTime = checkOut.getTime() - checkIn.getTime();

    // Convert time difference to days
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    return diffDays;
  };

  return (
    <div className="container">
      <div className="card shadow">
        <div className="card-body">
          {/* Header */}

          <div className="confirmation-header bg-white pb-3 rounded-top">
            <div className="row align-items-center">
              <div className="col-md-9">
                <h1 className="h2 mb-0 d-flex booking-head">
                  {/* <button
                  className="btn btn-light rounded-circle d-flex align-items-center justify-content-center me-2"
                  style={{ width: "40px", height: "40px" }}
                >
                  <ArrowBackIcon />
                </button> */}
                  Hotel Booking Confirmation
                </h1>
                <p className="lead text-success mb-0 success-pera">
                  <CheckIcon /> Your booking has been confirmed
                </p>
              </div>
              <div className="col-md-3  d-flex justify-content-end mt-md-0">
                <div className="d-flex">
                  <div className="me-2">
                    <p className=" text-muted">Booking Id:</p>
                    <p className="text-muted">Booking Date:</p>
                    <p className=" text-muted">Status:</p>
                  </div>
                  <div>
                    <p className="fw-bold">
                      Booking ID: {bookingRes?.BookingID}
                    </p>
                    {/* <p className="fw-bold">{bookingDate}</p> */}
                    <p className="fw-bold text-success">Confirmed</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Stay Details */}
          <div className="border-bottom pb-3 my-3">
            <div className="d-md-flex justify-content-between section-title">
              <h5 className="h4 ">Hotel Information</h5>
              <div className="user-button flight-booking-btns">
                <MuiButton
                  style={{ backgroundColor: "#425e65" }}
                  className="clear-btn w-100"
                  label="Download"
                  type="button"
                  startIcon={<FileDownloadIcon />}
                  onClick={() => downloadHotelTicket()}
                />
              </div>
            </div>

            <div className="row g-4">
              <div className="col-md-3">
                <div className="p-3 bg-light rounded stay-detail-box">
                  <p className="fw-medium mb-0">Check-in</p>
                  <p className="mb-0">{bookingRes?.booking_req?.checkInDate}</p>
                  <p className="mb-0">{bookingRes?.booking_req?.checkInTime}</p>
                </div>
              </div>
              <div className="col-md-3">
                <div className="p-3 bg-light rounded stay-detail-box">
                  <p className="fw-medium mb-0">Check-out</p>
                  <p className="mb-0">
                    {bookingRes?.booking_req?.checkOutDate}
                  </p>
                  <p className="mb-0">
                    {bookingRes?.booking_req?.checkOutTime}
                  </p>
                </div>
              </div>
              <div className="col-md-3">
                <div className="p-3 bg-light rounded stay-detail-box">
                  <div className="d-flex justify-content-around">
                    <div className="me-4">
                      <p className="fw-medium mb-0">Guests</p>
                      <p className="mb-0">
                        {bookingRes?.booking_req?.adultCount} Adults,
                        {bookingRes?.booking_req?.childCount} Child
                      </p>
                    </div>
                    <div>
                      <p className="fw-medium mb-0">Duration</p>

                      <p className="mb-0">
                        {calculateNights(
                          bookingRes?.booking_req?.checkInDate,
                          bookingRes?.booking_req?.checkOutDate
                        )}{" "}
                        Nights
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-3">
                <div className="p-3 bg-light rounded stay-detail-box">
                  <div className="d-flex justify-content-around">
                    <div className="me-4">
                      <p className="fw-medium mb-0">Room Type</p>
                      <p className="mb-0">
                        {bookingRes?.booking_req?.roomType}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Guest Information */}
          <div className="border-bottom pb-3 mb-2">
            <div className="row">
              <div className="col-md-8">
                <h3 className="fs-4 fw-semibold mb-3">Guest Information</h3>
                <div className="table-responsive">
                  <table className="table table-hover">
                    <thead className="table-light">
                      <tr>
                        <th>Full Name</th>
                        <th>Email Address</th>
                        <th>Contact Number</th>
                        <th>Nationality</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Saloni Garg</td>
                        <td>salonigarg8085@gmail.com</td>
                        <td>4567887654376</td>
                        <td>India</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div className="col-md-4">
                <h3 className="fs-4 fw-semibold mb-2">Payment Summary</h3>
                <div className="bg-light p-4 rounded info-card">
                  <div className="d-flex justify-content-between mb-2">
                    <span>1 Room X 1 Night</span>
                    <span>{bookingRes?.booking_req?.price}</span>
                  </div>
                  <div className="d-flex justify-content-between mb-2">
                    <span>Total Discount</span>
                    <span>{bookingRes?.booking_req?.disc}</span>
                  </div>
                  <div className="d-flex justify-content-between mb-2">
                    <span>Price After Discount</span>
                    <span>
                      {(() => {
                        const price = parseFloat(
                          bookingRes?.booking_req?.price || 0
                        );
                        const disc = parseFloat(
                          bookingRes?.booking_req?.disc || 0
                        );
                        const discountedPrice = price - disc;
                        return `${discountedPrice.toFixed(2)}`;
                      })()}
                    </span>
                  </div>
                  <div className="d-flex justify-content-between mb-2">
                    <span>Taxes & Service Fees</span>
                    <span>{bookingRes?.booking_req?.taxRate}</span>
                  </div>
                  <div className="border-top border-secondary-subtle my-2 pt-2 d-flex justify-content-between fw-semibold">
                    <span>Grand Total </span>
                    <span>{bookingRes?.booking_req?.totalAmount}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Call to Action */}
          <div className="row user-button gap-0  mt-4">
            <div className="col-md-3 col-6 mb-2">
              <MuiButton
                className="clear-btn w-100"
                label="Book Another Ticket"
                type="button"
                startIcon={<AddCircleOutlineIcon />}
                onClick={() => navigate("/hotelbooking")}
              />
            </div>
            {/* <div className="col-md-3 col-6 mb-2">
              <MuiButton
                className="clear-btn w-100 bg-primary"
                label="Back To Home"
                type="button"
                startIcon={<HomeIcon />}
                onClick={() => navigate("/dashboard")}
              />
            </div> */}
            <div className="col-md-3 col-6 mb-2">
              <MuiButton
                label="Booking History"
                className="main-btn get-btn w-100"
                type="submit"
                startIcon={<HistoryIcon />}
                onClick={() => navigate("/managehotelbooking")}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HotelBookingConfirmation;
